import api from "./PartnerPayDateApi";

import PartnerPayDate, { PartnerPayDateDefaultProps } from "../models/PartnerPayDate";
import PayMode from "../models/PayMode";
import PayCountType from "../models/PayCountType";
import PayDayType from "../models/PayDayType";
import Ledger from "../models/Ledger";

export class PartnerPayDateStore {

    partnerPayDate: PartnerPayDate = {...PartnerPayDateDefaultProps};
    payCountTypes: PayCountType[] = [];
    payModes: PayMode[] = [];
    payDayTypes: PayDayType[] = [];
    ledgers: Ledger[] = [];

    async loadPartnerPayDate(id: number) { 
        this.partnerPayDate = await api.getPartnerPayDate(id);
    }

    async updatePartnerPayDate() {
        await api.updatePartnerPayDate(this.partnerPayDate);
    }

    async removePartnerPayDate(id: number) {
        await api.removePartnerPayDate(id);
    }

    //---------

    async loadPayCountTypes() { 
        this.payCountTypes = await api.getPayCountTypes();
    }

    async loadPayModes() { 
        this.payModes = await api.getPayModes();
    }

    async loadPayDayTypes() { 
        this.payDayTypes = await api.getPayDayTypes();
    }

    async loadLedgers() { 
        this.ledgers = await api.getLedgers();
    }
}

const store = new PartnerPayDateStore();
export default store;